import { render, staticRenderFns } from "./AddGroupDialog.vue?vue&type=template&id=4366423a&scoped=true"
import script from "./AddGroupDialog.vue?vue&type=script&lang=ts"
export * from "./AddGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366423a",
  null
  
)

export default component.exports